import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router';
import LoginForm from '../components/login-form';
import useAuth from '../stores/useAuth';
import { DASHBOARD_PAGE } from '../routes/routeConstant';

export default function LoginPage() {
  const navigate = useNavigate();
  const { loading, isAuthenticated, checkAuth } = useAuth();

  useEffect(() => {
    checkAuth();
    if (isAuthenticated) {
      navigate(DASHBOARD_PAGE, { replace: true });
    }
  }, [isAuthenticated, navigate, checkAuth]);

  if (isAuthenticated) {
    return <Navigate to={DASHBOARD_PAGE} replace />;
  }

  if (loading && !isAuthenticated) {
    return (
      <div className="flex w-full h-dvh justify-center items-center">
        <div className="flex animate-pulse aspect-square size-32 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
          <img src="/assets/MSA-Logo.jpg" alt="MSA-Logo" className="rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="/" className="flex items-center gap-2 font-medium text-primary">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-neutral-900 text-neutral-50 dark:bg-neutral-50 dark:text-neutral-900">
              <img src="/assets/MSA-Logo.jpg" alt="MSA-Logo" className="rounded" />
            </div>
            PT Mulia Sujar Abadi
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm />
          </div>
        </div>
      </div>
      <div className="relative hidden bg-neutral-100 lg:block dark:bg-neutral-800">
        <img
          src="/assets/LoginImage.png"
          alt="LoginImageBg"
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  );
}
